
  export default {
    data() {
      return {
        scrolled: false,
        merchantPhone: null
      }
    },
    mounted() {
    //Pass expected role for auth
    this.merchantPhone = this.$config.GTHPH

  },
    methods: {
      removeSpace(num){
      return num.replace(/\s/g, "")
    },

      handleScroll() {
        this.scrolled = window.scrollY > 0;
      },
    },
    created() {
      if (process.browser)
        window.addEventListener('scroll', this.handleScroll);
    }
  }
